
export class LeagueFilter {
    startDate?:Date;
    endDate?: Date;
    sports?: number[];
    countries?: number[];
    leagueStatuses?:number[];
    visibilityStatuses?:number[];
    name?:string;
    organiserId?: number;
}
